<template>
  <cc-container>
    <cc-header-nav class="header" title="采满有赠">
      <template slot="right">
        <div class="ellipsis">
          <van-icon
            class="ellipsis-icon"
            name="ellipsis"
            @click.stop="isShowSmallNav = !isShowSmallNav"
          />
        </div>
      </template>
    </cc-header-nav>
    <cc-main>
      <div class="gift-info">
        <div class="gift-info-left">
          <span class="activity-tag">满赠</span>
        </div>
        <div class="gift-info-right">
          <p v-if="giftData.time_rr">{{giftData.time_rr.start_time+'-'+giftData.time_rr.end_time+'活动时间内'}}</p>
          <p v-for="item in giftData.gifts_contents" :key="item">{{item}}</p>
        </div>
      </div>
      <div class="gift">
        <div class="gift-goods" v-for="(item,index) in giftData.gifts_goods" :key="index">
          <div class="gift-goods-left">
            <img :src="item.image" alt />
             <div
                class="sellOut"
                v-if="item.goodsstock==0"
              >已抢光</div>
              <!-- 全场促销 -->
            <i class="qccx_img" v-if="item.is_enjoy_promotion"></i>
          </div>
          <div class="gift-goods-right">
            <p>
              <span>{{item.general_name}}</span>
              <span class="ml5">{{item.norms}}</span>
            </p>
            <p class="producer">{{item.produce_unit}}</p>
            <p class="p3 mt8">
              <span class="f18">
                <span class="f12">￥</span>
                {{item.jiage}}
              </span>
              <cc-svg-icon @click.stop="cartBtn(item,cartIconColor(item)?1:0)" size="24px" icon-class="shop-cart"  :class="cartIconColor(item)?'shopCartNoIcon':'shopCartIcon'"></cc-svg-icon>
            </p>
          </div>
        </div>
      </div>
    </cc-main>
    <cc-small-nav v-model="isShowSmallNav" />
 <!-- 购物车弹窗start(有库存) -->
      <cc-shop-cart
        :isShowPopup="showcart"
        :cartItemData="cartItem"
        @close="showcart=false"
        :height="556"
        :HeaderHight="88"
        ref="shopCart"
      ></cc-shop-cart>
    <!-- 购物车弹窗end -->
       <!-- 缺货弹窗start-->
      <cc-nogoods-remind
        :isShowPopup="shownogoods"
        :cartItem="cartItem"
        :height="426"
        @close="shownogoods=false"
        ref="nogoods"
      ></cc-nogoods-remind>
    <!-- 缺货弹窗end -->
  </cc-container>
</template>
<script>
import Vue from 'vue'
import { Icon, Lazyload } from 'vant'
import { loadGifts } from './../../fetch/goods-details/index.js'
import cartStep from '@/mixins/cartStep'

Vue.use(Icon)
  .use(Lazyload)

export default {
  mixins: [cartStep],
  data () {
    return {
      isShowSmallNav: false,
      giftData: ''
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    async loadData () {
      let { data } = await loadGifts({ for_id: this.$route.query.for_id })
      this.giftData = data
    },
    /**
     *  点击购物车购买
     */
    cartBtn (item, cartColor) {
      this.cartBtnAlter(item, cartColor)
    }
  }
}
</script>
<style lang='scss' scoped>
.ellipsis {
  width: 50%;
  height: 100%;
  @include center();
  transform: translateX(-5px);
  &-icon {
    transform: rotate(90deg);
  }
}
.activity-tag {
  padding: 2px 3px;
  font-size: 10px;
  background: #fce0e0;
  color: #fb5470;
  border-radius: 2px;
  line-height: 14px;
}
.header {
  color: #fff;
}
.gift-info {
  width: 100%;
  border-radius: 10px;
  margin: 10px 0;
  background: #fff;
  display: flex;
  padding: 10px 0 0 10px;
  box-sizing: border-box;
  // border-top:10px solid #ecebeb;
  &-right {
    line-height: 27px;
  }
  &-left {
    width: 80px;
    padding-top: 5px;
    box-sizing: 10px;
  }
}
.gift{
background: #fff;
height: 100%;
}
.gift-goods {
  background: #fff;
  // height: 130px;
  width: 100%;
  padding: 10px 10px 0 10px;
  // padding: 10px;
  box-sizing: border-box;
  display: flex;
  &-left {
    margin-right: 20px;
    position: relative;
    img {
      width: 100px;
      height: 100px;
      border-radius: 3px;
    }
    .qccx_img{
      bottom: 3px;
    }
  }
  &-right {
    width: 224px;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 15px;
    p:nth-child(1) {
      font-size: 15px;
      color: #333333;
      @include ell(2);
    }
    .producer {
      font-size: 12px;
      color: #777777;
    }
    .p3 {
      display: flex;
      justify-content: space-between;
      color: #ea2727;
    }
    p:nth-child(4) {
      .tag {
        font-size: 10px;
        color: #ccc;
        border: 1px solid #ccc;
        padding: 1.5px 3px;
        border-radius: 2px;
        margin-right: 5px;
      }
    }
    p:nth-child(5) {
      color: #f37f7f;
      font-size: 10px;
      @include ell(1);
      margin-top: 5px;
    }
  }
}
</style>
